import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";

export default [
  // 隱私權與服務條款
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/Info/Privacy')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '隱私權與服務條款'
    },
  },
  // 隱私權與服務條款
  {
    path: '/site-map',
    name: 'site-map',
    component: () => lazyLoadView(import('@views/Info/SiteMap')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '隱私權與服務條款'
    },
  },
]
